export class ApiConnectionError extends Error {
  readonly cause?: Error;

  constructor(cause?: unknown) {
    super('Connection failed');
    this.name = 'ApiConnectionError';
    if (cause instanceof Error) {
      this.cause = cause;
    }
  }
}

export class ApiHttpError extends Error {
  status: number;
  body?: unknown;

  constructor(status: number, message: string, body?: unknown) {
    super(message);
    this.name = 'ApiHttpError';
    this.status = status;
    this.body = body;
  }
}

export class NameCollisionError extends Error {
  assignedName: string;

  constructor(assignedName: string) {
    super('Name already taken');
    this.name = 'NameCollisionError';
    this.assignedName = assignedName;
  }
}

export function isRateLimited(error: unknown): boolean {
  return error instanceof ApiHttpError && error.status === 429;
}

export function isConnectionError(error: unknown): boolean {
  if (error instanceof ApiConnectionError) return true;
  if (error instanceof TypeError) return true;
  if (error instanceof Error) {
    const msg = error.message.toLowerCase();
    return (
      msg.includes('failed to fetch') ||
      msg.includes('networkerror') ||
      msg.includes('network request failed') ||
      msg.includes('load failed') ||
      msg.includes('connection failed')
    );
  }
  return false;
}

export function isNotFoundError(error: unknown): boolean {
  if (error instanceof ApiHttpError) return error.status === 404;
  if (error instanceof Error) return /\b404\b/.test(error.message);
  return false;
}
